import { useContext } from "react";
import { LocationContext } from "./App";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

export const Searchbar = ({ searchQuery }) => {
  const { handleSearchQuery, getLocation } = useContext(LocationContext);
  return (
    <Form style={{ marginTop: "2rem", marginBottom: "2rem" }}>
      <Form.Group>
        <Form.Control
          type="text"
          placeholder="search for a city"
          value={searchQuery}
          onChange={(e) => handleSearchQuery(e.target.value)}
        ></Form.Control>
      </Form.Group>
      <Button
        variant="primary"
        style={{ marginTop: "1rem" }}
        onClick={() => getLocation()}
      >
        Explore!
      </Button>
    </Form>
  );
};
